import React, { useState } from "react";
import "./OperationTeam.css";

const OperationTeam = () => {
  const [filter, setFilter] = useState("all"); // all | overloaded | idle | squad
  const [squadFilter, setSquadFilter] = useState("all");

  const collaborators = [
    {
      id: 1,
      name: "Ana Souza",
      role: "Coord. Atendimento",
      squad: "WhatsApp & SAC",
      tasksToday: 18,
      estTimeToday: 5.2, // horas
      capacityHours: 7,
      productivityIndex: 92,
      backlog: 3,
      lateTasks: 1,
      status: "balanced", // idle | balanced | overloaded
      automationUse: 68,
      tasks: [
        {
          id: "T-1012",
          title: "Revisar funil de reativação",
          origin: "WhatsApp Automation",
          due: "Hoje, 17:00",
          status: "Em andamento",
          impact: "Médio",
        },
        {
          id: "T-1013",
          title: "Ajustar respostas do bot financeiro",
          origin: "Fluxos Inteligentes",
          due: "Hoje, 16:00",
          status: "No prazo",
          impact: "Alto",
        },
        {
          id: "T-1014",
          title: "Call com time comercial",
          origin: "Manual",
          due: "Hoje, 18:00",
          status: "No prazo",
          impact: "Médio",
        },
      ],
    },
    {
      id: 2,
      name: "Bruno Lima",
      role: "Especialista em Cobrança",
      squad: "Financeiro",
      tasksToday: 24,
      estTimeToday: 8.5,
      capacityHours: 8,
      productivityIndex: 97,
      backlog: 7,
      lateTasks: 3,
      status: "overloaded",
      automationUse: 54,
      tasks: [
        {
          id: "C-2201",
          title: "Analisar clientes com fatura D+7",
          origin: "Automação de Tarefas",
          due: "Hoje, 15:30",
          status: "Atrasado",
          impact: "Alto",
        },
        {
          id: "C-2202",
          title: "Revisar script de cobrança amigável",
          origin: "WhatsApp Automation",
          due: "Hoje, 19:00",
          status: "No prazo",
          impact: "Médio",
        },
      ],
    },
    {
      id: 3,
      name: "Carla Menezes",
      role: "SDR Pleno",
      squad: "Pré-vendas",
      tasksToday: 9,
      estTimeToday: 3.1,
      capacityHours: 7,
      productivityIndex: 81,
      backlog: 1,
      lateTasks: 0,
      status: "idle",
      automationUse: 73,
      tasks: [
        {
          id: "L-3301",
          title: "Qualificar leads de campanha H2",
          origin: "Fluxos Inteligentes",
          due: "Hoje, 16:30",
          status: "No prazo",
          impact: "Alto",
        },
      ],
    },
    {
      id: 4,
      name: "Diego Rocha",
      role: "Suporte Técnico",
      squad: "Pós-venda",
      tasksToday: 15,
      estTimeToday: 6.0,
      capacityHours: 7,
      productivityIndex: 88,
      backlog: 4,
      lateTasks: 1,
      status: "balanced",
      automationUse: 39,
      tasks: [
        {
          id: "S-4401",
          title: "Analisar tickets com SLA em risco",
          origin: "WhatsApp Automation",
          due: "Hoje, 17:30",
          status: "No prazo",
          impact: "Alto",
        },
      ],
    },
  ];

  const [selectedId, setSelectedId] = useState(collaborators[0].id);
  const selected = collaborators.find((c) => c.id === selectedId);

  const filteredCollaborators = collaborators.filter((colab) => {
    if (filter === "overloaded" && colab.status !== "overloaded") return false;
    if (filter === "idle" && colab.status !== "idle") return false;
    if (filter === "squad" && squadFilter !== "all" && colab.squad !== squadFilter)
      return false;
    return true;
  });

  const handleCreateTask = () => {
    alert("Aqui abriria o modal de 'Criar Tarefa' com sugestão de distribuição automática.");
  };

  const handleDistribute = (mode) => {
    if (mode === "idle") {
      alert("Sugestão: distribuir novas tarefas para quem está com capacidade ociosa.");
    }
    if (mode === "squad") {
      alert("Sugestão: enviar tarefas deste tipo para o time especializado selecionado.");
    }
    if (mode === "expert") {
      alert("Sugestão: enviar tarefas críticas para o especialista mais indicado.");
    }
  };

  return (
    <div className="OperationTeam">
      {/* Cabeçalho */}
      <header className="ot-header">
        <div>
          <p className="ot-kicker">Operações da Equipe</p>
          <h1 className="ot-title">Produtividade, capacidade e distribuição inteligente</h1>
          <p className="ot-subtitle">
            Acompanhe a carga de trabalho da equipe, identifique gargalos,
            distribua tarefas automaticamente e veja a performance individual de cada pessoa.
          </p>
        </div>
        <div className="ot-header-actions">
          <button className="ot-btn-secondary">Ver relatórios avançados</button>
          <button className="ot-btn-primary" onClick={handleCreateTask}>
            + Criar tarefa
          </button>
        </div>
      </header>

      {/* Métricas gerais */}
      <section className="ot-metrics">
        <div className="ot-metric-card">
          <span className="label">Tarefas atribuídas hoje</span>
          <strong>66</strong>
          <span className="hint">somando atendimento, cobrança e suporte</span>
        </div>
        <div className="ot-metric-card">
          <span className="label">Capacidade média utilizada</span>
          <strong>78%</strong>
          <span className="hint">equilíbrio geral da operação</span>
        </div>
        <div className="ot-metric-card">
          <span className="label">Tarefas atrasadas</span>
          <strong>5</strong>
          <span className="hint">priorizar financeiro e suporte</span>
        </div>
        <div className="ot-metric-card">
          <span className="label">Automatização média por pessoa</span>
          <strong>59%</strong>
          <span className="hint">tarefas já geradas por automações FASTEAM</span>
        </div>
      </section>

      {/* Layout principal */}
      <section className="ot-main">
        {/* Lista de colaboradores */}
        <div className="ot-card ot-list-card">
          <div className="ot-card-header">
            <div>
              <h2>Equipe e carga de trabalho</h2>
              <p>Veja quem está sobrecarregado, equilibrado ou ocioso hoje.</p>
            </div>
          </div>

          <div className="ot-filters">
            <button
              className={
                filter === "all" ? "ot-filter-btn ot-filter-btn-active" : "ot-filter-btn"
              }
              onClick={() => setFilter("all")}
            >
              Todos
            </button>
            <button
              className={
                filter === "overloaded"
                  ? "ot-filter-btn ot-filter-btn-active"
                  : "ot-filter-btn"
              }
              onClick={() => setFilter("overloaded")}
            >
              Sobrecarregados
            </button>
            <button
              className={
                filter === "idle" ? "ot-filter-btn ot-filter-btn-active" : "ot-filter-btn"
              }
              onClick={() => setFilter("idle")}
            >
              Ociosos
            </button>
            <button
              className={
                filter === "squad" ? "ot-filter-btn ot-filter-btn-active" : "ot-filter-btn"
              }
              onClick={() => setFilter("squad")}
            >
              Por time
            </button>

            {filter === "squad" && (
              <select
                className="ot-squad-select"
                value={squadFilter}
                onChange={(e) => setSquadFilter(e.target.value)}
              >
                <option value="all">Todos os squads</option>
                <option value="WhatsApp & SAC">WhatsApp & SAC</option>
                <option value="Financeiro">Financeiro</option>
                <option value="Pré-vendas">Pré-vendas</option>
                <option value="Pós-venda">Pós-venda</option>
              </select>
            )}
          </div>

          <table className="ot-table">
            <thead>
              <tr>
                <th>Colaborador</th>
                <th>Squad</th>
                <th>Tarefas hoje</th>
                <th>Tempo estimado</th>
                <th>Capacidade utilizada</th>
                <th>Atrasos</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredCollaborators.map((c) => {
                const capacityUse = Math.round((c.estTimeToday / c.capacityHours) * 100);
                return (
                  <tr
                    key={c.id}
                    className={c.id === selectedId ? "row-selected" : undefined}
                    onClick={() => setSelectedId(c.id)}
                  >
                    <td>
                      <div className="ot-person">
                        <div className="ot-avatar">{c.name.charAt(0)}</div>
                        <div>
                          <div className="ot-person-name">{c.name}</div>
                          <div className="ot-person-role">{c.role}</div>
                        </div>
                      </div>
                    </td>
                    <td>{c.squad}</td>
                    <td>{c.tasksToday}</td>
                    <td>{c.estTimeToday.toFixed(1)}h</td>
                    <td>
                      <div className="ot-capacity-wrapper">
                        <div className="ot-capacity-bar">
                          <div
                            className={`ot-capacity-fill ${
                              capacityUse > 100
                                ? "ot-capacity-high"
                                : capacityUse > 80
                                ? "ot-capacity-medium"
                                : "ot-capacity-low"
                            }`}
                            style={{
                              width: `${Math.min(capacityUse, 120)}%`,
                            }}
                          />
                        </div>
                        <span className="ot-capacity-label">{capacityUse}%</span>
                      </div>
                    </td>
                    <td>{c.lateTasks}</td>
                    <td>
                      <span
                        className={
                          c.status === "overloaded"
                            ? "ot-status ot-status-overloaded"
                            : c.status === "idle"
                            ? "ot-status ot-status-idle"
                            : "ot-status ot-status-balanced"
                        }
                      >
                        {c.status === "overloaded" && "Sobrecarregado"}
                        {c.status === "idle" && "Ocioso"}
                        {c.status === "balanced" && "Equilibrado"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Detalhe do colaborador + automação de distribuição */}
        {selected && (
          <div className="ot-card ot-detail-card">
            <div className="ot-card-header">
              <div>
                <h2>Visão individual do colaborador</h2>
                <p>
                  Acompanhe entregas, capacidade, atrasos e uso de automações para{" "}
                  <strong>{selected.name}</strong>.
                </p>
              </div>
            </div>

            <div className="ot-detail-layout">
              {/* Painel do colaborador */}
              <div className="ot-detail-main">
                <div className="ot-profile-header">
                  <div className="ot-avatar-large">
                    {selected.name.charAt(0)}
                  </div>
                  <div>
                    <div className="ot-profile-name">{selected.name}</div>
                    <div className="ot-profile-role">
                      {selected.role} • {selected.squad}
                    </div>
                    <div className="ot-profile-tags">
                      <span className="ot-chip">
                        Produtividade: {selected.productivityIndex}%
                      </span>
                      <span className="ot-chip">
                        Uso de automações: {selected.automationUse}%
                      </span>
                    </div>
                  </div>
                </div>

                <div className="ot-stats-grid">
                  <div className="ot-stat">
                    <span className="label">Tarefas hoje</span>
                    <strong>{selected.tasksToday}</strong>
                    <span className="hint">incluindo automáticas e manuais</span>
                  </div>
                  <div className="ot-stat">
                    <span className="label">Tempo estimado</span>
                    <strong>{selected.estTimeToday.toFixed(1)}h</strong>
                    <span className="hint">
                      capacidade diária: {selected.capacityHours}h
                    </span>
                  </div>
                  <div className="ot-stat">
                    <span className="label">Backlog</span>
                    <strong>{selected.backlog}</strong>
                    <span className="hint">tarefas em fila para os próximos dias</span>
                  </div>
                  <div className="ot-stat">
                    <span className="label">Tarefas atrasadas</span>
                    <strong>{selected.lateTasks}</strong>
                    <span className="hint">
                      priorizar no roteamento automático
                    </span>
                  </div>
                </div>

                <div className="ot-tasks-today">
                  <span className="ot-section-title">Tarefas de hoje</span>
                  <ul className="ot-task-list">
                    {selected.tasks.map((t) => (
                      <li key={t.id} className="ot-task-item">
                        <div className="ot-task-main">
                          <span className="ot-task-title">{t.title}</span>
                          <span className="ot-task-origin">{t.origin}</span>
                        </div>
                        <div className="ot-task-meta">
                          <span className="ot-task-due">{t.due}</span>
                          <span
                            className={
                              t.status === "Atrasado"
                                ? "ot-task-status ot-task-status-late"
                                : "ot-task-status"
                            }
                          >
                            {t.status}
                          </span>
                          <span
                            className={
                              t.impact === "Alto"
                                ? "ot-task-impact ot-task-impact-high"
                                : "ot-task-impact"
                            }
                          >
                            Impacto {t.impact}
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Automação de distribuição */}
              <div className="ot-detail-side">
                <div className="ot-auto-card">
                  <span className="ot-section-title">
                    Automação de distribuição de tarefas
                  </span>
                  <p className="ot-auto-text">
                    Defina como o FASTEAM deve distribuir automaticamente as novas
                    tarefas geradas por fluxos, integrações ou cadastros manuais.
                  </p>

                  <div className="ot-auto-options">
                    <button
                      className="ot-auto-btn"
                      onClick={() => handleDistribute("idle")}
                    >
                      Enviar para quem estiver ocioso
                    </button>
                    <button
                      className="ot-auto-btn"
                      onClick={() => handleDistribute("squad")}
                    >
                      Enviar para o time especializado
                    </button>
                    <button
                      className="ot-auto-btn"
                      onClick={() => handleDistribute("expert")}
                    >
                      Enviar para especialista
                    </button>
                  </div>

                  <div className="ot-auto-note">
                    <p>
                      O algoritmo de distribuição considera capacidade disponível,
                      nível de produtividade, atrasos recentes e tipo da tarefa.
                    </p>
                    <p>
                      Você pode usar esta lógica dentro dos módulos de{" "}
                      <strong>Automação de Tarefas</strong>,{" "}
                      <strong>WhatsApp Automation</strong> e{" "}
                      <strong>Fluxos Inteligentes</strong>.
                    </p>
                  </div>
                </div>

                <div className="ot-auto-card ot-auto-card-mini">
                  <span className="ot-section-title">
                    Alertas para gestores
                  </span>
                  <ul className="ot-alert-list">
                    <li>
                      <strong>Bruno</strong> está acima de 100% da capacidade hoje.
                      Sugestão: mover parte das tarefas de cobrança para Ana.
                    </li>
                    <li>
                      <strong>Carla</strong> está com carga ociosa. Sugestão: direcionar
                      novos leads de pré-vendas para ela.
                    </li>
                    <li>
                      Tarefas de <strong>pós-venda</strong> com alto impacto devem ser
                      sempre direcionadas para <strong>especialista</strong>.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default OperationTeam;
